import React from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { toastError, toastSuccess } from '../../shared/toastr'
import { AccountApi } from '../../services/AccountApi'
import { useOfferionTranslation } from '../../shared/store/hooks/useOfferionTranslation'
import { Button } from '../shared/Button'
import { BackgroundBlockPattern } from '../shared/GridBackground'
import { FormInput } from '../shared/form/FormInput'
import { FormField } from '../shared/form/FormField'
import { useNavigate, useLocation } from 'react-router-dom'

export const ResetPasswordContainer = () => {
    const { t } = useOfferionTranslation()
    const location = useLocation()
    const navigate = useNavigate()

    const schema = Yup.object().shape({
        password: Yup.string()
            .required(t('Allaround.Validation.required', { fieldName: t('Registration.accountdataPassword') }))
            .min(6, t('Allaround.Validation.minLength', { fieldName: t('Registration.accountdataPassword'), minLength: 6 })),
        password2: Yup.string()
            .required(t('Allaround.Validation.required', { fieldName: t('Registration.accountdataPassword') }))
            .min(6, t('Allaround.Validation.minLength', { fieldName: t('Registration.accountdataPassword'), minLength: 6 }))
            .oneOf([Yup.ref('password')], t('Allaround.Validation.passwordsDontMatch')),
    })

    const onSubmit = async ({ password }: { password: string }) => {
        const queryParams = new URLSearchParams(location.search)
        const token = queryParams.get('token')
        const userId = queryParams.get('userId')
        if (token == null || userId == null) {
            toastError('ResetPassword.showErrorMessage')
            console.error('Missing query params')
            return
        }

        await AccountApi.resetPassword(token, userId, password)
        toastSuccess('ResetPassword.showSuccessMessage')

        navigate('/')
    }

    return (
        <div className="v2-root bg-white w-full h-full flex flex-col justify-between">
            <main className="font-sans w-full h-full pt-12 sm:pt-16 md:pt-32 px-5">
                <div className="w-full md:bg-grey10  flex flex-col gap-8 max-w-[430px] mx-auto md:p-10 rounded-[14px] md:border md:border-border">
                    <span className="text-xl text-grey100">{t('ResetPassword.title')}</span>
                    <Formik initialValues={{ password: '', password2: '' }} onSubmit={onSubmit} validationSchema={schema}>
                        <Form className="flex flex-col gap-4">
                            <FormField
                                component={FormInput}
                                name="password"
                                type="password"
                                placeholder={t('ResetPassword.passwordPlaceholder')}
                            />

                            <FormField
                                component={FormInput}
                                name="password2"
                                type="password"
                                placeholder={t('ResetPassword.passwordRepeatPlaceholder')}
                            />

                            <Button type="submit" variant="primary" className="mt-4">
                                {t('ResetPassword.buttonText')}
                            </Button>
                        </Form>
                    </Formik>
                </div>

                <BackgroundBlockPattern />
            </main>
        </div>
    )
}
